import './index.css'

const PlayerCard = ({player, vote})=>{
    return(
        <div className="player-card-container">
            <img width={100} src={player?.img} alt={player?.name} />
            <p className="player-card-name">{player?.name}</p>
            {
                vote && <button className="player-card-vote-btn" onClick={()=>vote(player)}>Votar</button>
            }
            

        </div>
    )
}

export default PlayerCard